'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var initialCache = {
  options: [],
  hasMore: true,
  isLoading: false
};

var AsyncPaginate = function (_Component) {
  _inherits(AsyncPaginate, _Component);

  function AsyncPaginate(props) {
    var _this2 = this;

    _classCallCheck(this, AsyncPaginate);

    var _this = _possibleConstructorReturn(this, (AsyncPaginate.__proto__ || Object.getPrototypeOf(AsyncPaginate)).call(this, props));

    _this.onClose = function () {
      _this.setState({
        search: ''
      });
    };

    _this.onOpen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.state.optionsCache['']) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.loadOptions();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.onInputChange = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.setState({
                  search: search
                });

              case 2:
                if (_this.state.optionsCache[search]) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return _this.loadOptions();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.onMenuScrollToBottom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this$state, search, optionsCache, currentOptions;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state = _this.state, search = _this$state.search, optionsCache = _this$state.optionsCache;
              currentOptions = optionsCache[search];

              if (!currentOptions) {
                _context3.next = 5;
                break;
              }

              _context3.next = 5;
              return _this.loadOptions();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));


    var initialOptionsCache = props.options ? {
      '': {
        isLoading: false,
        options: props.options,
        hasMore: true
      }
    } : {};

    _this.state = {
      search: '',
      optionsCache: initialOptionsCache
    };
    return _this;
  }

  _createClass(AsyncPaginate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref4) {
      var cacheUniq = _ref4.cacheUniq;

      if (cacheUniq !== this.props.cacheUniq) {
        this.setState({
          optionsCache: {}
        });
      }
    }
  }, {
    key: 'loadOptions',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _state, search, optionsCache, currentOptions, _ref6, options, hasMore;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _state = this.state, search = _state.search, optionsCache = _state.optionsCache;
                currentOptions = optionsCache[search] || initialCache;

                if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return this.setState({
                  search: search,
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    isLoading: true
                  })))
                });

              case 6:
                _context4.prev = 6;
                _context4.next = 9;
                return this.props.loadOptions(search, currentOptions.options);

              case 9:
                _ref6 = _context4.sent;
                options = _ref6.options;
                hasMore = _ref6.hasMore;
                _context4.next = 14;
                return this.setState({
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    options: currentOptions.options.concat(options),
                    hasMore: !!hasMore,
                    isLoading: false
                  })))
                });

              case 14:
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](6);
                _context4.next = 20;
                return this.setState({
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    isLoading: false
                  })))
                });

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 16]]);
      }));

      function loadOptions() {
        return _ref5.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: 'render',
    value: function render() {
      var selectRef = this.props.selectRef;
      var _state2 = this.state,
          search = _state2.search,
          optionsCache = _state2.optionsCache;


      var currentOptions = optionsCache[search] || initialCache;

      return _react2.default.createElement(_reactSelect2.default, _extends({}, this.props, {
        onClose: this.onClose,
        onOpen: this.onOpen,
        onInputChange: this.onInputChange,
        onMenuScrollToBottom: this.onMenuScrollToBottom,
        isLoading: currentOptions.isLoading,
        options: currentOptions.options,
        ref: selectRef
      }));
    }
  }]);

  return AsyncPaginate;
}(_react.Component);

AsyncPaginate.propTypes = {
  loadOptions: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheUniq: _propTypes2.default.any,
  selectRef: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
AsyncPaginate.defaultProps = {
  cacheUniq: null,
  selectRef: function selectRef() {},
  options: null
};
exports.default = AsyncPaginate;


//////////////////
// WEBPACK FOOTER
// ./~/react-select-async-paginate/lib/index.js
// module id = 2342
// module chunks = 0